module.exports = __webpack_public_path__ + "static/media/30-3.64ea9366.mp3";